<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent max-width="800px">
      <v-card :loading="loading" :disabled="cardDisabled">
        <v-card-title>
          <span class="headline">{{ $t('Study') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-alert
              text
              prominent
              dismissible
              v-model="alertShow"
              type="error"
              icon="mdi-alert"
            >{{ alertText }}</v-alert>
            <v-form ref="form">
              <v-row>
                <v-col class="column-border" cols="12">
                  <v-col class="text-right borderless-column">
                    <v-btn text small color="primaryLigth" @click="copyStudy()">
                      <span>Copy</span>
                    </v-btn>
                    <v-btn text small v-if="updateEnable" color="primaryLigth" @click="changeJsonViewerEditorMode()">
                      <span v-if="jsonViewerEditorMode">View</span>
                      <span v-else>Edit</span>
                    </v-btn>
                  </v-col>
                  <JsonViewer
                    v-if="!jsonViewerEditorMode"
                    :value="dicomJson"
                    :expand-depth="2"
                    stort
                  ></JsonViewer>
                  <v-textarea
                    v-else
                    outlined
                    name="input-7-4"
                    ref="editedDicomJson"
                    v-model="editedDicomJson"
                    :auto-grow="autoGrow"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="outlinedButton">
                  <v-btn
                    class="ma-2"
                    tile
                    outlined
                    color="red"
                    v-if="deleteEnable"
                    dense
                    @click="deleteStudy"
                  >
                    <v-icon left>mdi-delete</v-icon>
                    {{ $t('Delete Study') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="hide">{{ $t('close') }}</v-btn>
          <v-btn
            color="darken-1"
            text
            :disabled="!jsonViewerEditorMode"
            v-if="updateEnable"
            @click="updateStudy"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import i18n from "../../i18n";
import EventBus from "../../event-bus";
import JsonViewer from "vue-json-viewer";

export default {
  name: "UpdateStudyModal",
  components: {
    JsonViewer,
  },
  props: {},
  data: () => ({
    showModal: false,
    loading: false,
    autoGrow: true,
    cardDisabled: false,
    errorMessages: [],
    alertText: null,
    alertShow: false,
    studyId: null,
    study: null,
    dicomJson: null,
    editedDicomJson: null,
    updateEnable: false,
    deleteEnable: false,
    accessionNumber: null,
    studyDateTime: null,
    expireAt: null,
    jsonViewerEditorMode: false,
  }),
  mounted() {
    // Permissions
    this.deleteEnable = this.$store.getters.resources.worklist.delete;
    this.updateEnable = this.$store.getters.resources.worklist.update;
  },
  methods: {
    sendErrorAndCloseModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }

      this.loading = false;
      this.showModal = false;
    },
    sendErrorOnModal(error) {
      if (error.response) {
        if (
          error.response.status == 400 &&
          error.response.data.status == "error"
        ) {
          this.alertText = error.response.data.error;
        } else {
          this.alertText = error.response.data;
        }
      } else {
        this.alertText = error;
      }

      this.loading = false;
      this.alertShow = true;
    },
    show(id) {
      this.alertShow = false;
      this.alertText = "";
      this.studyId = id;

      axios({
        url: "/api/v1/worklist/study/" + id,
        headers: { "Content-Type": "application/json" },
        method: "GET",
      })
        .then((response) => {
          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.showModal = false;
            EventBus.$emit("SHOW_ERROR", response);
          } else {
            this.study = response.data.study;
            this.accessionNumber = response.data.study.accessionNumber;
            this.studyDateTime = response.data.study.studyDateTime;
            this.expireAt = response.data.study.expireAt;
            this.dicomJson = response.data.study.dicom;
            this.jsonViewerEditorMode = false;
            this.showModal = true;
          }
        })
        .catch((error) => {
          this.sendErrorAndCloseModal(error);
        });
    },
    updateStudy() {
      this.alertShow = false;
      this.alertText = "";

      let newDicomJson = {};

      try {
        newDicomJson = JSON.parse(this.editedDicomJson);
      } catch (err) {
        let textarea = this.$refs.editedDicomJson.$el.querySelector("textarea");
        let jsonerror = JSON.stringify(err.message);
        this.sendErrorOnModal(jsonerror);
        if (jsonerror.indexOf("position") > -1) {
          // Highlight error position
          var positionStr = jsonerror.lastIndexOf("position") + 8;
          var posi = parseInt(
            jsonerror.substr(positionStr, jsonerror.lastIndexOf('"'))
          );
          if (posi >= 0) {
            textarea.onfocus = function () {
              textarea.setSelectionRange(posi, posi + 1);
            };
            textarea.focus();
          }
        }
        return;
      }

      this.loading = true;

      axios({
        url: "/api/v1/worklist/study/" + this.studyId,
        headers: { "Content-Type": "application/json" },
        data: newDicomJson,
        method: "PUT",
      })
        .then((response) => {
          this.loading = false;

          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.sendErrorOnModal(response);
          } else {
            this.jsonViewerEditorMode = false;
          }
        })
        .catch((error) => {
          this.sendErrorOnModal(error);
        });
    },
    deleteStudy() {
      axios({
        url: "/api/v1/worklist/study/" + this.studyId,
        method: "DELETE",
      })
        .then((response) => {
          this.loading = false;
          if (response.data.status && response.data.status == "done") {
            this.$parent.$parent.updateTable();
            this.hide();
          } else {
            EventBus.$emit("SHOW_ERROR", response.data.error);
          }
        })
        .catch((error) => {
          this.sendErrorAndCloseModal(error);
        });
    },
    changeJsonViewerEditorMode() {
      this.editedDicomJson = JSON.stringify(this.dicomJson, null, 2);
      this.jsonViewerEditorMode = !this.jsonViewerEditorMode;
    },
    copyStudy() {
      navigator.clipboard.writeText(JSON.stringify(this.study.dicom, null, 2));
      EventBus.$emit("SHOW_SNACKBAR", i18n.t("Copied to clipboard!"), 1000);
    },
    hide() {
      this.showModal = false;
    },
  },
};
</script>

<style>
.v-alert {
  overflow: hidden;
}

.disable-events {
  pointer-events: none;
}

.outlinedButton {
  padding: 4px !important;
}

.jv-item {
  color: black !important;
}

.jv-key {
  font-weight: bold;
}

.jv-code {
  padding-top: 0px !important;
}

.borderless-column {
  padding: 0px !important;
}

.column-border {
  margin: 12px;
  border: 1px;
  border-style: solid;
  max-width: 97% !important;
}

::-moz-selection {
  color: white;
  background-color: black;
}
::selection {
  color: white;
  background-color: black;
}
</style>